/* CorporateAV.ae product page (Stage 4): gallery, floating WhatsApp handling, sticky navigation, FAQ anchor. No dependencies. */
(function () {
  /* Backup for the CSS rule in cav-product.css: hide the global floating WhatsApp (.whatsapp-float) on mobile product pages. */
  function hideFloatingWhatsApp() {
    if (!document.querySelector('.cav-sticky-cta')) return;
    Array.prototype.forEach.call(document.querySelectorAll('.whatsapp-float'), function (el) { el.classList.add('cav-hide-mobile'); });
  }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', hideFloatingWhatsApp); } else { hideFloatingWhatsApp(); }

  var g = document.querySelector('[data-cav-gallery]');
  if (g) {
    var main = g.querySelector('[data-cav-main]');
    var thumbs = g.querySelectorAll('[data-cav-thumb]');
    Array.prototype.forEach.call(thumbs, function (b) {
      b.addEventListener('click', function () {
        if (!main) return;
        main.src = b.getAttribute('data-src');
        main.srcset = b.getAttribute('data-srcset') || '';
        main.alt = b.getAttribute('data-alt') || '';
        Array.prototype.forEach.call(thumbs, function (x) { x.setAttribute('aria-current', 'false'); });
        b.setAttribute('aria-current', 'true');
      });
    });
  }

  var faq = document.querySelector('.myFaqs');
  if (faq && !document.getElementById('cav-faq')) {
    var sec = faq.closest('.shopify-section') || faq;
    sec.id = 'cav-faq';
  }

  var nav = document.querySelector('[data-cav-nav]');
  var sentinel = document.querySelector('[data-cav-nav-sentinel]');
  if (!nav) return;

  /* Reconcile links with rendered sections even when sticky observers are unavailable. */
  var navLinks = Array.prototype.slice.call(nav.querySelectorAll('a[href^="#"]'));
  var map = {};
  navLinks.forEach(function (a) {
    var t = document.getElementById(a.getAttribute('href').slice(1));
    a.parentNode.hidden = !t;
    if (t) map[t.id] = a;
  });
  if (!('IntersectionObserver' in window)) return;

  /* Keep the fixed product navigation below the store header when the header is visible (sticky on scroll up). */
  var header = document.querySelector('.section-header');
  var ticking = false;
  function placeNav() {
    ticking = false;
    if (!nav.classList.contains('is-fixed')) { nav.style.top = ''; return; }
    var top = 0;
    if (header && header.classList.contains('shopify-section-header-sticky') && !header.classList.contains('shopify-section-header-hidden')) {
      top = Math.max(0, Math.round(header.getBoundingClientRect().bottom));
    }
    nav.style.top = top + 'px';
  }
  function requestPlace() { if (!ticking) { ticking = true; window.requestAnimationFrame(placeNav); } }
  window.addEventListener('scroll', requestPlace, { passive: true });
  window.addEventListener('resize', requestPlace);
  if (header && 'MutationObserver' in window) { new MutationObserver(requestPlace).observe(header, { attributes: true, attributeFilter: ['class', 'style'] }); }

  if (sentinel) {
    new IntersectionObserver(function (es) {
      es.forEach(function (e) { nav.classList.toggle('is-fixed', !e.isIntersecting && e.boundingClientRect.top < 0); requestPlace(); });
    }).observe(sentinel);
  }
  var io = new IntersectionObserver(function (es) {
    es.forEach(function (e) {
      if (e.isIntersecting) {
        navLinks.forEach(function (a) { a.removeAttribute('aria-current'); });
        var a = map[e.target.id];
        if (a) { a.setAttribute('aria-current', 'true'); }
      }
    });
  }, { rootMargin: '-35% 0px -60% 0px' });
  Object.keys(map).forEach(function (id) { io.observe(document.getElementById(id)); });
})();